import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-panel",
  "use": "icon-panel-usage",
  "viewBox": "0 0 1260 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1260 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-panel\"><defs><style type=\"text/css\"></style></defs><path d=\"M157.538462 157.538462v551.384615h945.230769V157.538462H157.538462zM0 0h1260.307692v866.461538H0V0z m157.538462 945.230769h945.230769v78.769231H157.538462v-78.769231z\" p-id=\"1826\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol